const SECOND_LEFT = 30;
export default {
  data() {
    return {
      isSend: false,
      secondLeft: SECOND_LEFT
    };
  },
  methods: {
    sendCode() {
      this.$emit('send');
    },
    countDown() {
      this.isSend = true;
      const delayTime = 1000;
      const timer = setInterval(() => {
        if (this.secondLeft === 1) {
          clearInterval(timer);
          this.isSend = false;
          this.secondLeft = SECOND_LEFT;
        } else {
          this.secondLeft -= 1;
        }
      }, delayTime);
    }
  }
};